<template>
  <ob-modal2 :show.sync="show" width="840px" :backdrop="false">
    <template slot="modal-title">Work Authorization History</template>
    <template slot="modal-body">
        <div v-if="showSection">
            <div v-if="( workAuthDetails != null && workAuthDetails.length > 0 ) || ( workAuthPrevDetails != null && workAuthPrevDetails.length > 0)">
                    <div class="col-md-12">
                        <p v-if="workAuthDetails.length>0" style="font-weight:650;font-size:12px;">All the approved card details corresponding to previous Work Authorization type are displayed below.</p>
                        <div id="content">
                            <ul class="timeline">
                                <li class="event" v-for="(workAuthRec,indexW) in workAuthDetails" :key="indexW">
                                    <h4 class="heading mL0">{{workAuthRec.WorkAuthType}} <span v-if="workAuthRec.WorkAuthType.includes('US Citizen') && workAuthRec.Name != null && workAuthRec.Name != ''">({{workAuthRec.Name}})</span><span v-if="workAuthRec.IsCurrentWorkDoc" class="current-tag">Current</span></h4>

                                    <p class="sub-heading mL0">
                                        <span v-if="!(workAuthRec.WorkAuthType.includes('EAD OTHERS') || workAuthRec.WorkAuthType.includes('STEM OPT') ||
                                                workAuthRec.WorkAuthType.includes('OPT EAD') || workAuthRec.WorkAuthType.includes('CPT') ||
                                                workAuthRec.WorkAuthType.includes('Green Card')|| workAuthRec.WorkAuthType.includes('US Citizen'))">
                                            Receipt Number - <span v-if="workAuthRec.ReceiptNumber != null && workAuthRec.ReceiptNumber != ''">{{workAuthRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                        </span>
                                        <span v-else-if="workAuthRec.WorkAuthType.includes('CPT')">
                                            SEVIS ID - <span v-if="workAuthRec.ReceiptNumber != null && workAuthRec.ReceiptNumber != ''">{{workAuthRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                        </span>
                                        <span v-else>
                                            Card Number - <span v-if="workAuthRec.ReceiptNumber != null && workAuthRec.ReceiptNumber != ''">{{workAuthRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                        </span> | validity -
                                        <span v-if="workAuthRec.WorkAuthType.includes('CAP-GAP (I-20)') || workAuthRec.WorkAuthType.includes('EXTENSION RECEIPT (I-797C)')">
                                            <span v-if="workAuthRec.EndDate != null && workAuthRec.EndDate != ''">{{workAuthRec.EndDate}}</span><span v-else>N/A</span>
                                        </span>
                                        <span v-else>
                                            <span v-if="workAuthRec.StartDate != null && workAuthRec.StartDate != ''">{{workAuthRec.StartDate}}</span><span v-else>N/A</span> to
                                            <span v-if="workAuthRec.EndDate != null && workAuthRec.EndDate != ''">{{workAuthRec.EndDate}}</span><span v-else>N/A</span>
                                        </span>
                                    </p>
                                    <div style="margin-top:15px;">
                                        <div class="col-md-4 pL0" v-if="workAuthRec.ProjectTitle != null && workAuthRec.ProjectTitle.length > 0">
                                            <label>Project Title</label>
                                            <p class="para" v-for="project in workAuthRec.ProjectTitle">{{project}}</p> <!--loop the projects -->
                                        </div>
                                        <div class="col-md-4 pL0" v-if="workAuthRec.CaseNumber != null && workAuthRec.CaseNumber.length > 0">
                                            <label>Linked LCA Case Number</label>
                                            <p class="para" v-for="casenumber in workAuthRec.CaseNumber">{{casenumber}}</p> <!--loop the case number -->
                                        </div>
                                    </div>
                                    <div class='clearfix'></div>
                                    <hr class="hr_line">
                                    <div v-for="document in (workAuthRec.Documents)">
                                        <p class="docList mL0"  @click="previewSingleDoc(document.Value)"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_document_blue.svg`" alt="document">  <a class="view-link">{{document.Name}}</a></p> <!--loop the Documents -->
                                    </div>
                                </li>
                                <div v-if="workAuthPrev" style="padding-bottom: 10px;">
                                    <p style="padding:8px 10px;background: #dcdcdc;font-size: 14px;font-weight: 600;color: #333;">Previous organization's Work Authorizations</p>
                                </div>
                                <li class="event" v-if="!workAuthPrevRec.isRemoved" v-for="(workAuthPrevRec,workAuthIndex) in workAuthPrevDetails">
                                    <div v-if="!workAuthPrevRec.isEdit">
                                        <h4 class="heading mL0">{{workAuthPrevRec.WorkAuthType}}</h4>
                                        <p style="float:right">
                                            <!-- <img v-if="workAuthPrevRec.isEditDisabled || !workAuthPrevRec.IsEditable" src="/static/Images/ic_edit.svg" style="padding-right:8px;cursor:no-drop" disabled="disabled"> -->
                                            <img v-if="workAuthPrevRec.IsEditable" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_edit.svg`" @click="editWorkAuth(workAuthPrevRec)" style="padding-right:8px;cursor:pointer;">
                                            <!-- <img v-if="!workAuthPrevRec.IsEditable" src="/static/Images/ic_delete.svg" style="cursor:no-drop;" disabled="disabled"> -->
                                            <img v-if="workAuthPrevRec.IsEditable" @click="removeWorkAuth(workAuthPrevRec)" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_delete.svg`" style="cursor:pointer">
                                        </p>
                                        <p class="sub-heading mL0">
                                            <span v-if="!(workAuthPrevRec.WorkAuthType.includes('EAD OTHERS') || workAuthPrevRec.WorkAuthType.includes('STEM OPT') ||
                                                workAuthPrevRec.WorkAuthType.includes('OPT EAD') || workAuthPrevRec.WorkAuthType.includes('CPT') ||
                                                workAuthPrevRec.WorkAuthType.includes('Green Card')|| workAuthPrevRec.WorkAuthType.includes('US Citizen'))">
                                                Receipt Number - <span v-if="workAuthPrevRec.ReceiptNumber != null && workAuthPrevRec.ReceiptNumber != ''">{{workAuthPrevRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                            </span>
                                            <span v-else-if="workAuthPrevRec.WorkAuthType.includes('CPT')">
                                                SEVIS ID - <span v-if="workAuthPrevRec.ReceiptNumber != null && workAuthPrevRec.ReceiptNumber != ''">{{workAuthPrevRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                            </span>
                                            <span v-else>
                                                Card Number - <span v-if="workAuthPrevRec.ReceiptNumber != null && workAuthPrevRec.ReceiptNumber != ''">{{workAuthPrevRec.ReceiptNumber}}</span><span v-else>N/A</span>
                                            </span> | validity - <span v-if="workAuthPrevRec.StartDate != null && workAuthPrevRec.StartDate != ''">{{workAuthPrevRec.StartDate}}</span><span v-else>N/A</span> to <span v-if="workAuthPrevRec.EndDate != null && workAuthPrevRec.EndDate != ''">{{workAuthPrevRec.EndDate}}</span><span v-else>N/A</span>
                                        </p>
                                        <div style="margin-top:15px;">
                                            <div class="col-md-4 pL0">
                                                <label>Company Name</label>
                                                <p class="para">{{workAuthPrevRec.CompanyName}}</p> <!--loop the projects -->
                                            </div>
                                        </div>
                                        <div class='clearfix'></div>
                                        <hr v-if="!( workAuthPrevRec.Documents != null && workAuthPrevRec.Documents.length > 0 ) && !(workAuthPrevDetails !=null && workAuthPrevDetails.length == 1) && !(workAuthIndex == (workAuthPrevDetails.length - 1))  " class="hr_line1">
                                        <hr v-if="( workAuthPrevRec.Documents != null && workAuthPrevRec.Documents.length > 0 )" class="hr_line">
                                        <div v-for="document in (workAuthPrevRec.Documents)">
                                            <p @click="previewSingleDoc(document.Value)" class="docList mL0"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_document_blue.svg`" alt="document">  <a class="view-link">{{document.Name}}</a></p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row divalign">
                                            <div class="col-md-3 pL0">
                                                <div class="form-group">
                                                    <label>Work Authorization Type<span class="rcss-text-red">*</span></label>
                                                    <ob-select2 v-model="WorkPermitTypeEdit" :inModal="true" :class="{'ob-vuelidate_input-error' : $v.WorkPermitTypeEdit.$error}" :options="employmentAuthorizationOptions" @updated="(v) => this.WorkPermitTypeEdit = v"></ob-select2>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.WorkPermitTypeEdit.$dirty && !$v.WorkPermitTypeEdit.required">Please select work auth type</span>
                                                </div>
                                            </div>
                                            <div v-if="isH1BFlag" class="col-md-3 pL0">
                                                <div class="form-group">
                                                    <label>Receipt Number<span class="rcss-text-red">*</span></label>
                                                    <ob-input v-model.trim ="ReceiptNumberEdit" maxLength="13" :class="{'ob-vuelidate_input-error' : $v.ReceiptNumberEdit.$error}" placeholder="Enter Receipt Number"></ob-input>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.ReceiptNumberEdit.$dirty && !$v.ReceiptNumberEdit.required">Please enter receipt number</span>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.ReceiptNumberEdit.$dirty && $v.ReceiptNumberEdit.required && !$v.ReceiptNumberEdit.alphanumerichyphen">Please enter a valid receipt number</span>
                                                </div>
                                            </div>
                                            <div v-else class="col-md-3 pL0">
                                                <div v-if="isCPT" class="form-group">
                                                    <label>SEVIS ID<span class="rcss-text-red">*</span></label>
                                                    <ob-input v-model="CardNumberEdit" :class="{'ob-vuelidate_input-error' : $v.CardNumberEdit.$error}" placeholder="Enter SEVIS ID" key="sevisid"></ob-input>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.CardNumberEdit.$dirty && !$v.CardNumberEdit.required">Please enter SEVIS ID</span>
                                                </div>
                                                <div v-else class="form-group">
                                                    <label>Card Number<span class="rcss-text-red">*</span></label>
                                                    <ob-input v-model="CardNumberEdit" :class="{'ob-vuelidate_input-error' : $v.CardNumberEdit.$error}" placeholder="Enter Card Number" key="cardnumber"></ob-input>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.CardNumberEdit.$dirty && !$v.CardNumberEdit.required">Please enter card number</span>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Work Authorization Validation<span class="rcss-text-red">*</span></label>
                                                    <div class="row">
                                                        <div class="col-md-6 pR0">
                                                            <ob-date-time-picker id="WorkAuthFromDateEdit" ref="WorkAuthFromDateEdit" :class="{'ob-vuelidate_input-error' : $v.WorkAuthFromDateEditValue.$error}" :inputvalue="WorkAuthFromDateEditValue" v-model="WorkAuthFromDateEditValue" @updated="(v) => this.WorkAuthFromDateEditValue = v" :options="workAuthDateOptions" :dpchange="FromDateChange"  placeholder="From"></ob-date-time-picker>
                                                            <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthFromDateEditValue.$dirty && !$v.WorkAuthFromDateEditValue.required">Please enter from date</span>
                                                        </div>
                                                        <div class="col-md-6 pR0">
                                                            <ob-date-time-picker id="WorkAuthToDateEdit" ref="WorkAuthToDateEdit" :class="{'ob-vuelidate_input-error' : $v.WorkAuthToDateEditValue.$error}" :inputvalue="WorkAuthToDateEditValue" v-model="WorkAuthToDateEditValue" :options="workAuthDateOptions" @updated="getUpdateToDateVal" placeholder="To" :dpchange="ToDateChange"></ob-date-time-picker>
                                                            <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthToDateEditValue.$dirty && !$v.WorkAuthToDateEditValue.required">Please enter to date</span>
                                                            <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthToDateEditValue.$dirty && $v.WorkAuthToDateEditValue.required && !$v.WorkAuthToDateEditValue.between">End date should be same or before the Work Authorization From Date</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m0">
                                            <div class="col-md-3 pL0">
                                                <div class="form-group">
                                                    <label>Company Name<span class="rcss-text-red">*</span></label>
                                                    <ob-input v-model="CompanyNameEdit" :class="{'ob-vuelidate_input-error' : $v.CompanyNameEdit.$error}" placeholder="Enter Company Name"></ob-input>
                                                    <span class="ob-vuelidate_error-msg" v-if="$v.CompanyNameEdit.$dirty && !$v.CompanyNameEdit.required">Please enter company name</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row m0">
                                            <div class="col-md-12 pL0">
                                                <!-- <label> Upload Document</label> -->
                                                <template v-for="(item,indexE) in EditAttachments">
                                                    <div class="attachments-view">
                                                        <template>
                                                            <span id="task-title">
                                                            {{getFileNameEdit(item.Value)}}
                                                            </span>
                                                        </template>
                                                        <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px;margin-right: 10px;">
                                                        <span class="cross-mark" @click="removeAttachmentEdit(workAuthIndex,indexE)" style="font-size: 11px; padding: 2px 5px;" >&#10006;</span></span>
                                                    </div>
                                                </template>
                                                <div v-if="EditAttachmentDiv">
                                                    <ob-upload-attachment ref="uploadEdit" @error-msg="IsInvalidFileEdit" @file-inProgress="InProgressEdit" @file-complete="onuploadCompleteEdit(workAuthIndex,...arguments)" :validation="validationUpload" :end-point="EndPoint" :type="1" :IsFileExists="filenameEdit" :attach-file.sync="attachFile" >
                                                        <template slot="file-text">
                                                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                                                        </template>
                                                    </ob-upload-attachment>
                                                </div>
                                                <div class="form-group col-md-12 pL0">
                                                    <a @click="onAddAtachmentEdit()">
                                                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="padding-top:8px">
                                                    <span style="color: #000000;font-weight: 600;font-size: 12px;margin-right:3px">
                                                    Upload Documents
                                                    </span>
                                                    </a>
                                                </div>
                                                <!-- <div>
                                                    <ob-upload-new :validation="ValidationAuthUpload" :end-point="EndPoint" :type="2"
                                                                    :IsFileExists="eadDocumentUrlEdit" :isUploading.sync="isUploading"
                                                                    @remove-file="removeFileEdit"
                                                                    @file-complete="updateFileCtzenDocEdit">
                                                        <template slot="file-text">
                                                            <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose File  No File Choosen
                                                        </template>
                                                    </ob-upload-new>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="row m0">
                                            <div class="col-md-12 pL0" style="padding-top:10px;">
                                                <ob-button type="primary" style="margin-bottom:15px" @click="WorkAuthEdit(workAuthPrevRec)">Save</ob-button>
                                                <ob-button type="secondary" style="margin-bottom:15px" @click="cancelEdit(workAuthPrevRec)">Cancel</ob-button>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                <!-- <div style=" border-bottom: 1px dashed #dcdcdc;" v-if="(workAuthDetails.length > 0 || workAuthPrevDetails.length > 0)">
                </div> -->
                <div class="work-auth-heading">
                    <div class="row m0">
                        <div class="col-md-12">
                        <p style="font-weight:600;font-size:12px;">You can add your previous organization's Work Authorizations here.</p>
                        </div>
                    </div>
                </div>
                <div class="work-auth" v-if="addAnotherWorkAuth">
                    <div class="row divalign">
                        <div class="col-md-3 pR0">
                            <div class="form-group">
                                <label>Work Authorization Type<span class="rcss-text-red">*</span></label>
                                <ob-select2 v-model="WorkPermitType" :inModal="true" :class="{'ob-vuelidate_input-error' : $v.WorkPermitType.$error}" :options="employmentAuthorizationOptions" @updated="(v) => this.WorkPermitType = v"></ob-select2>
                                <span class="ob-vuelidate_error-msg" v-if="$v.WorkPermitType.$dirty && !$v.WorkPermitType.required">Please select work auth type</span>
                            </div>
                        </div>
                        <div v-if="isH1B" class="col-md-3 pR0">
                        <div class="form-group">
                            <label>Receipt Number<span class="rcss-text-red">*</span></label>
                            <ob-input :maxLength="13" placeholder="Enter Receipt Number" v-model.trim="ReceiptNumber" :class="{'ob-vuelidate_input-error' : $v.ReceiptNumber.$error}" ></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.ReceiptNumber.$dirty && !$v.ReceiptNumber.required">Please enter receipt number</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.ReceiptNumber.$dirty && $v.ReceiptNumber.required && !$v.ReceiptNumber.alphanumerichyphen">Please enter a valid receipt number</span>
                        </div>
                        </div>
                        <div v-else class="col-md-3 pR0">
                            <div v-if="isCPT" class="form-group">
                                <label>SEVIS ID<span class="rcss-text-red">*</span></label>
                                <ob-input v-model="CardNumber" :class="{'ob-vuelidate_input-error' : $v.CardNumber.$error}" placeholder="Enter SEVIS ID"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.CardNumber.$dirty && !$v.CardNumber.required">Please enter SEVIS ID</span>
                            </div>
                            <div v-else class="form-group">
                                <label>Card Number<span class="rcss-text-red">*</span></label>
                                <ob-input v-model="CardNumber" :class="{'ob-vuelidate_input-error' : $v.CardNumber.$error}" placeholder="Enter Card Number"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.CardNumber.$dirty && !$v.CardNumber.required">Please enter card number</span>
                            </div>
                        </div>
                        <div class="col-md-4 pR0">
                            <div class="form-group">
                                <label>Work Authorization Validation<span class="rcss-text-red">*</span></label>
                                <div class="row">
                                <div class="col-md-6 pR0">
                                    <ob-date-time-picker id="dateFrom" ref="dateFrom1" :class="{'ob-vuelidate_input-error' : $v.WorkAuthFromDate.$error}" :inputvalue="WorkAuthFromDate" :options="workAuthDateOptions" @updated="(v) => this.WorkAuthFromDate = v" placeholder="From" :dpchange="onFromDateChange"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthFromDate.$dirty && !$v.WorkAuthFromDate.required">Please enter from date</span>
                                </div>
                                <div class="col-md-6 pR0">
                                    <ob-date-time-picker id="dateTo" ref="dateTo1" :class="{'ob-vuelidate_input-error' : $v.WorkAuthToDate.$error}" :inputvalue="WorkAuthToDate" :options="workAuthDateOptions" @updated="(v) => this.WorkAuthToDate = v" placeholder="To"></ob-date-time-picker>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthToDate.$dirty && !$v.WorkAuthToDate.required">Please enter to date</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.WorkAuthToDate.$dirty && $v.WorkAuthToDate.required && !$v.WorkAuthToDate.between">End date should be same or before the Work Authorization From Date</span>
                                </div>
                        </div>
                            </div>
                        </div>
                        <div class="col-md-2" style="padding: 15px 0px 0px;">
                            <a @click="removeWorkAuthDoc" class="remove-worklocation"><i class="fa fa-minus" aria-hidden="true"></i>  Remove</a>
                        </div>
                    </div>
                    <div class="row m0">
                        <div class="col-md-3 pR0">
                            <div class="form-group">
                                <label>Company Name<span class="rcss-text-red">*</span></label>
                                <ob-input v-model="CompanyName" :class="{'ob-vuelidate_input-error' : $v.CompanyName.$error}" placeholder="Enter Company Name"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.CompanyName.$dirty && !$v.CompanyName.required">Please enter company name</span>
                            </div>
                        </div>
                    </div>
                    <div class="row m0">
                        <div class="col-md-12 padding-15">
                            <template v-for="(item,index) in Attachments">
                                <div class="attachments-view">
                                    <template>
                                        <span id="task-title">
                                        {{getFileName(item)}}
                                        </span>
                                    </template>
                                    <span style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px;margin-right: 10px;">
                                    <span class="cross-mark" @click="removeAttachment(index)" style="font-size: 11px; padding: 2px 5px;" >&#10006;</span></span>
                                </div>
                            </template>
                            <div v-if="showAttachmentDiv">
                                <ob-upload-attachment ref="upload" @error-msg="IsInvalidFile" @file-inProgress="InProgress" @file-complete="onuploadComplete" :validation="validationUpload" :end-point="EndPoint" :type="1" :IsFileExists="filename" :attach-file.sync="attachFile" >
                                    <template slot="file-text">
                                        <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                                    </template>
                                </ob-upload-attachment>
                            </div>
                            <!-- <label> Upload Document</label>
                            <div>
                                <ob-upload-new :validation="ValidationAuthUpload" :end-point="EndPoint" :type="2"
                                                :IsFileExists="eadDocumentUrl" :isUploading.sync="isUploading"
                                                @remove-file="removeFile"
                                                @file-complete="updateFileCtzenDoc">
                                    <template slot="file-text">
                                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose File  No File Choosen
                                    </template>
                                </ob-upload-new>
                            </div> -->
                            <!-- <div v-if="addAnotherDoc">
                                <ob-upload-new :validation="ValidationAuthUpload" :end-point="EndPoint" :type="2"
                                                :IsFileExists="eadDocumentUrlAnother" :isUploadingAnother="isUploadingAnother"
                                                @remove-file="removeAnotherFile"
                                                @file-complete="updateFileCtzenDocAnother">
                                    <template slot="file-text">
                                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop OR Choose File  No File Choosen
                                    </template>
                                </ob-upload-new>
                            </div> -->
                        </div>
                    </div>
                    <div class="row m0">
                        <div class="col-md-12">
                            <div style="padding: 10px 0 15px;">
                                <div class="form-group col-md-12 pL0" style="padding-top:10px">
                                    <a @click="onAddAtachment()">
                                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="padding-top:8px">
                                    <span style="color: #000000;font-weight: 600;font-size: 12px;margin-right:3px">
                                    Upload Documents
                                    </span>
                                    </a>
                                </div>
                                <!-- <div v-if="eadDocumentUrl == null || eadDocumentUrl == '' || isUploading">
                                    <a style="font-size:14px;font-weight:bold;color:blue;text-decoration:underline;" disabled>Add Another Document</a>
                                </div>
                                <div v-else>
                                    <a style="font-size:14px;font-weight:bold;color:blue;text-decoration:underline;" @click="addAnother">Add Another Document</a>
                                </div> -->
                            </div>
                            <ob-button type="primary" style="margin-bottom:15px" @click="uploadWorkAuth">Save</ob-button>
                        </div>
                    </div>
                </div>
                <p v-if="!addWorkAuthDisable" @click="showAuth" class="AddWorkAuth"><span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="padding-top:8px">  Add Work Authorization</span></p>
                <p v-else class="AddWorkAuthDisable"><span style="cursor:not-allowed;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="padding-top:8px">  Add Work Authorization</span></p>
            </div>
            <div class="no-workauth" v-else>
                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_noworkauth.png`">
                <p style="padding: 30px 0;">No Work Authorization details to display!</p>
            </div>
        </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="CancelPopUp">Close</ob-button>
      <ob-button v-if="( workAuthDetails != null && workAuthDetails.length > 0 ) || ( workAuthPrevDetails != null && workAuthPrevDetails.length > 0)" type="primary" @click="DownloadEmployeeWorkAuthHistory">Download as Pdf</ob-button>
       <ob-button v-if="( workAuthDetails != null && workAuthDetails.length > 0 ) || ( workAuthPrevDetails != null && workAuthPrevDetails.length > 0)" type="secondary" @click="showWorkAuthComposeMail">Share</ob-button>
    </template>
  </ob-modal2>
</template>
<script>
import utils from '@/components/Core/utils.js'
import c from '@/components/Core/constants.js'
import CommonFunctionMixin from '../ESSProfile/Timesheets/CommonFunctionMixin.js'
import { required, maxLength } from 'vuelidate/lib/validators'
import { req, withParams } from 'vuelidate/lib/validators/common'
import jquery from 'jquery'
const alphanumerichyphen = (value) => {
    var alphanuhy = /[A-Za-z]{3}[0-9]{2}[0-9]{3}[0-9]{5}/
        return alphanuhy.test(value)
    }
export default {
  mixins: [CommonFunctionMixin],
  props: ["openModal", "consultantObj", "empStartDate"],
  data() {
    return {
        show: false,
        showSection:false,
        EmpId:'',
        WorkAuthDocumentUrl:'',
        workAuthDetails:[],
        workAuthPrevDetails:[],
        addAnotherWorkAuth: false,
        //isUploading: false,
        //isUploadingAnother: false,
        //addAnotherDoc:false,
        isH1B:false,
        isH1BFlag:false,
        isCPT: false,
        //eadDocumentUrl: '',
        //eadDocumentUrlAnother: '',
        EndPoint: `${c.APIBASEURL}/File/FileUpload?isPrivate=true`,
        CardNumber:'',
        ReceiptNumber:'',
        CompanyName:'',
        WorkPermitType: '',
        WorkAuthFromDate:'',
        WorkAuthToDate:'',
        workAuthDateOptions: {
            format: 'MM/DD/YYYY',
            dayViewHeaderFormat: 'MM/DD/YYYY',
            widgetPositioning: {
                  horizontal: 'left',
                  vertical: 'bottom'
              }
        },
        employmentAuthorizationOptions:{
            placeholder: {
                id: '-1',
                text: 'Select Work Authorization Type'
            },

            data: [
                { id: '0', text: '' },
                { id: 'H-1B', text: 'H-1B' },
                { id: 'New H-1B (CAP)', text: 'New H-1B (CAP)' },
                { id: 'H-1B Extension', text: 'H-1B Extension' },
                { id: 'H-1B Transfer', text: 'H-1B Transfer' },
                { id: 'H-1B Concurrent', text: 'H-1B Concurrent' },
                { id: 'H-1B Amendment', text: 'H-1B Amendment' },
                { id: 'New H-1B (CAP Exempt)', text: 'New H-1B (CAP Exempt)' },
                { id: 'Green Card', text: 'Green Card' },
                { id: 'US Citizen', text: 'US Citizen' },
                { id: 'CPT', text: 'CPT' },
                { id: 'EAD OTHERS', text: 'EAD OTHERS' },
                { id: 'OPT EAD', text: 'OPT EAD' },
                { id: 'STEM OPT', text: 'STEM OPT' }
            ]
        },
        validationUpload: {
            Rules: {
                Type: ["pdf", "png", "jpg", "jpeg", "JPG", "JPEG", "PNG"],
                Size: 2500000, // In Bytes
                multiplefiles: true
            },
            Messages: {
                Type: "Please upload valid file formats",
                Size: `Please upload a file which is less than 25MB`,
            },
            excludeList:false
        },
        filename:[],
        filenameEdit:[],
        attachFile:false,
        addWorkAuthDisable:false,
        //workAuthId:[],
        CardNumberEdit:'',
        ReceiptNumberEdit:'',
        CompanyNameEdit:'',
        WorkPermitTypeEdit: '',
        WorkAuthFromDateEditValue:'',
        WorkAuthToDateEditValue:'',
        //eadDocumentUrlEdit: '',
        showAttachmentDiv:false,
        Attachments:[],
        EditAttachmentDiv:false,
        EditAttachments:[],
        Documents:[],
        EmpStartDate:'',
        HistoryLink:''
    };
  },
  created(){
        events.listen(`WorkAuthSaveSuccess`, () => {
            this.getWorkAuthorizationHistory();
        });
  },
    validations() {
        return {
            WorkPermitType:{
            required
            },
            CompanyName: {
                required
            },
            CardNumber:{
            required
            },
            ReceiptNumber:{
            required,
            maxLength:maxLength(20),
            alphanumerichyphen
            },
            WorkAuthFromDate: {
                required
            },
            WorkAuthToDate: {
                required,
                between: (WorkAuthToDate) => moment(WorkAuthToDate).isBetween(this.WorkAuthFromDate, this.WorkAuthToDate, null, '[]')
            },
            WorkPermitTypeEdit:{
            required
            },
            CompanyNameEdit: {
                required
            },
            CardNumberEdit:{
            required
            },
            ReceiptNumberEdit:{
            required,
            maxLength:maxLength(20),
            alphanumerichyphen
            },
            WorkAuthFromDateEditValue: {
                required
            },
            WorkAuthToDateEditValue: {
                required,
                between: (WorkAuthToDateEditValue) => moment(WorkAuthToDateEditValue).isBetween(this.WorkAuthFromDateEditValue, this.WorkAuthToDateEditValue, null, '[]')
            },
        }
    },
    computed: {
        workAuthPrev(){
            if(this.workAuthPrevDetails.length>0)
            return true
            else
            return false
        }
    },
  methods: {
    onAddAtachmentEdit(){
        this.EditAttachmentDiv = true
        this.openEdit()
    },
    openEdit() {
        setTimeout(() => {
        this.$refs.uploadEdit[0].uploadNew();
        }, 1000)
    },
    IsInvalidFileEdit(error){
        if(error != '')
        {
            this.$message({
            type: 'error',
            message: error
            });
        }
    },
    InProgressEdit(){
        this.$loading({'loadingText': 'Loading...'})
        this.EditAttachmentDiv = true
    },
    onuploadCompleteEdit(index,v){
        for(var i=0 ; i<v.length ; i++)
        {
            if (v[i].response.Url != null)

            var doc = {
                Name : utils.I9URL2FileName(v[i].response.Url),
                Value : v[i].response.Url
            }
            this.EditAttachments.push(doc)
            //this.workAuthPrevDetails[index].Documents.push(doc)
        }
       // this.EditAttachments =  this.workAuthPrevDetails[index].Documents
        this.EditAttachmentDiv = false
        this.$loading({}).close()
    },
    getFileNameEdit(item){
        var filename = utils.I9URL2FileName(item);
        return filename
    },
    onAddAtachment(){
        this.showAttachmentDiv = true
        this.open()
    },
    removeAttachmentEdit(workAuthIndex,indexE){
        //this.workAuthPrevDetails[workAuthIndex].Documents.splice(indexE,1)
        this.EditAttachments.splice(indexE,1)
    },
    open() {
        setTimeout(() => {
        this.$refs.upload.uploadNew();
        }, 1000)
    },
     IsInvalidFile(error)
    {
      if(error != '')
      {
        this.$message({
          type: 'error',
          message: error
        });
      }
    },
    InProgress()
    {
      this.$loading({'loadingText': 'Loading...'})
      this.showAttachmentDiv = true
    },
    onuploadComplete(v) {
      for(var i=0 ; i<v.length ; i++)
      {
        if (v[i].response.Url != null)
          this.Attachments.push(v[i].response.Url)
      }
      this.showAttachmentDiv = false
      this.$loading({}).close()
    },
    removeAttachment(index)
    {
      this.Attachments.splice(index, 1);
    },
    getFileName(item)
    {
      var filename = utils.I9URL2FileName(item);
       return filename
    },
    getUpdateFromDateVal(v){
    this.WorkAuthFromDateEditValue = v
    },
    getUpdateToDateVal(v){

    this.WorkAuthToDateEditValue = v
    },
    showWorkAuthComposeMail(){
      this.$loading({'loadingText': 'Loading...'})
        ajax.get(`Employee/${this.EmpId}/DownloadEmployeeWorkAuthHistory`,{},res => {
          this.$loading({}).close()
            if(res.data.State == true){
                this.DownloadEmployeeWorkAuthHistoryLink=res.data.Message
                this.DocumentAttachment = res.data.Name
                 let link = this.DownloadEmployeeWorkAuthHistoryLink + "&download=true";
                 let doc = {
                    Name: this.DocumentAttachment,
                    Url: this.DownloadEmployeeWorkAuthHistoryLink
                 }
                 this.$emit('openWorkAuthComposeMailPopup', doc)
                 //this.isShowComposeMail = true;
                 //this.show =false
            }
            else{
                this.$message({
                    type:'error',
                    message:res.data.Message
                });
            }
        });

    },
    CancelPopUp() {
        this.show = false;
        this.addAnotherWorkAuth = false
        this.addWorkAuthDisable = false
        //this.addAnotherDoc = false

    },
    showAuth(){
        this.addAnotherWorkAuth = true
        this.addWorkAuthDisable = true
        setTimeout(()=>{
            this.$refs.dateFrom1.data.maxDate(this.EmpStartDate)
            this.$refs.dateFrom1.value = this.EmpStartDate
        },500)
    },
    onFromDateChange(e){
      this.$refs.dateFrom1.data.maxDate(this.EmpStartDate)
      this.$refs.dateTo1.data.minDate(e.date)
    },
    FromDateChange(e){
    this.$refs.WorkAuthFromDateEdit[0].data.maxDate(this.EmpStartDate)
    this.$refs.WorkAuthToDateEdit[0].data.minDate(e.date)
    if(this.EmpStartDate < this.WorkAuthFromDateEditValue){
        this.WorkAuthFromDateEditValue = this.EmpStartDate
    }
    else{
        var fromEditValue = jquery('#WorkAuthFromDateEdit').val();
        this.WorkAuthFromDateEditValue = fromEditValue
    }
    },
    ToDateChange(e) {
        var mindate = this.$refs.WorkAuthFromDateEdit.value
        if(mindate != '')
            this.$refs.WorkAuthToDateEdit[0].data.minDate(mindate)
    },
    reset(){
        this.$v.WorkPermitType.$reset()
        this.$v.CompanyName.$reset()
        this.$v.CardNumber.$reset()
        this.$v.ReceiptNumber.$reset()
        this.$v.WorkAuthFromDate.$reset()
        this.$v.WorkAuthToDate.$reset()
    },
    resetEdit(){
        this.$v.WorkPermitTypeEdit.$reset()
        this.$v.CompanyNameEdit.$reset()
        this.$v.CardNumberEdit.$reset()
        this.$v.ReceiptNumberEdit.$reset()
        this.$v.WorkAuthFromDateEditValue.$reset()
        this.$v.WorkAuthToDateEditValue.$reset()
    },
    uploadWorkAuth(){
        this.$v.WorkPermitType.$touch()
        this.$v.CompanyName.$touch()
        this.$v.CardNumber.$touch()
        this.$v.ReceiptNumber.$touch()
        this.$v.WorkAuthFromDate.$touch()
        this.$v.WorkAuthToDate.$touch()
        var isEAD = false;
        var isCardValidated = false;
        if(!(this.WorkPermitType =='EAD OTHERS' || this.WorkPermitType =='STEM OPT' || this.WorkPermitType =='OPT EAD' || this.WorkPermitType =='CPT' || this.WorkPermitType =='Green Card'|| this.WorkPermitType =='US Citizen')){
            isCardValidated = !this.$v.ReceiptNumber.$invalid
            isEAD = false;
        }
        else{
            isCardValidated = !this.$v.CardNumber.$invalid
            isEAD = true;
        }

        if(this.$v.WorkPermitType.$invalid == false && isCardValidated && this.$v.CompanyName.$invalid == false && this.$v.WorkAuthFromDate.$invalid == false && this.$v.WorkAuthToDate.$invalid == false){
            var cardNo;
            if(!isEAD)
                cardNo = this.ReceiptNumber
            else
                cardNo = this.CardNumber
            let params = {
                "WorkAuthType" :this.WorkPermitType ,
                "CardNumber" : cardNo,
                "CompanyName" : this.CompanyName,
                "StartDate" : this.WorkAuthFromDate,
                "EndDate" : this.WorkAuthToDate,
                "Documents" : this.Attachments
            }
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`Employee/${this.EmpId}/SaveWorkAuthorizationHistory`,params,(res)=>{
                if(res.data.State == true){
                    this.$loading({}).close()
                    this.addWorkAuthDisable = false
                    this.addAnotherWorkAuth = false
                    this.clearValues()
                    this.reset()
                    this.$message({
                        type: 'success',
                        message: res.data.Message
                    })
                    events.fire("WorkAuthSaveSuccess")
                }
                else{
                    this.$loading({}).close()
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                }
            });

        }
    },
    getWorkAuthorizationHistory(){
        if(this.EmpId != null && this.EmpId != ''){
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.get(`Employee/${this.EmpId}/GetWorkAuthorizationHistory`, {}, res => {
                this.$loading({}).close()
                if(res.data.State == true) {
                let WorkAuthList = []
                if(res.data.WorkAuthDetails && res.data.WorkAuthDetails.Existing.length > 0 )
                this.workAuthDetails = res.data.WorkAuthDetails.Existing
                if(res.data.WorkAuthDetails && res.data.WorkAuthDetails.Previous.length > 0 ){
                WorkAuthList = res.data.WorkAuthDetails.Previous
                }
                WorkAuthList.forEach((t) => {
                    Vue.set(t, 'isEdit', false)
                    Vue.set(t, 'isEditDisabled', false)
                    Vue.set(t, 'isRemoved', false)
                })
                this.workAuthPrevDetails = WorkAuthList
                this.showSection = true
                }
                else{
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    });
                }
            });
        }
    },
    DownloadEmployeeWorkAuthHistory(){
      this.$loading({'loadingText': 'Downloading...'})
        ajax.get(`Employee/${this.EmpId}/DownloadEmployeeWorkAuthHistory`,{},res => {
          this.$loading({}).close()
            if(res.data.State == true){
                this.HistoryLink=res.data.Message
                 let link = this.HistoryLink + "&download=true";
                    window.open(link, '_blank')
            }
            else{
                this.$message({
                    type:'error',
                    message:res.data.Message
                });
            }
        });
    },
    clearValuesEdit(){
        if(this.$refs.WorkAuthFromDateEdit)
            this.$refs.WorkAuthFromDateEdit.value = ''
        if(this.$refs.WorkAuthToDateEdit)
            this.$refs.WorkAuthToDateEdit.value = ''
        this.WorkPermitTypeEdit = ''
        this.CompanyNameEdit = ''
        this.CardNumberEdit = ''
        this.ReceiptNumberEdit = ''
        this.WorkAuthFromDateEditValue = ''
        this.WorkAuthToDateEditValue = ''
    },
    clearValues(){
        this.WorkPermitType = ''
        this.CompanyName = ''
        this.CardNumber = ''
        this.ReceiptNumber = ''
        this.WorkAuthFromDate = ''
        this.WorkAuthToDate = ''
        this.Attachments = []
    },
    removeWorkAuthDoc(){
        this.addAnotherWorkAuth = false
        this.addWorkAuthDisable = false
        this.clearValues()
        this.reset()
    },
    editWorkAuth(obj){
    var editDocList = this.workAuthPrevDetails.filter(x => x.isEdit)
        if(!(editDocList != null && editDocList.length > 0)){
            this.workAuthPrevDetails.forEach((t) => {
                if(t.Id == obj.Id)
                    Vue.set(t, 'isEdit', true)
                else
                    Vue.set(t, 'isEditDisabled', true)
            })
            this.WorkPermitTypeEdit = obj.WorkAuthType
            this.CompanyNameEdit = obj.CompanyName
            this.WorkAuthFromDateEditValue = obj.StartDate
            this.WorkAuthToDateEditValue = obj.EndDate
            setTimeout(()=>{
                 this.$refs.WorkAuthFromDateEdit.value = obj.StartDate
                this.$refs.WorkAuthToDateEdit.value = obj.EndDate
            },1000)
            this.EditAttachments = obj.Documents
            if(!(this.WorkPermitTypeEdit =='EAD OTHERS' || this.WorkPermitTypeEdit =='STEM OPT' || this.WorkPermitTypeEdit =='OPT EAD' || this.WorkPermitTypeEdit =='CPT' || this.WorkPermitTypeEdit =='Green Card'|| this.WorkPermitTypeEdit =='US Citizen')){
                this.ReceiptNumberEdit = obj.ReceiptNumber
                this.CardNumberEdit = ''
                this.isH1BFlag = true
            }
            else{
                this.CardNumberEdit = obj.ReceiptNumber
                this.ReceiptNumberEdit = ''
                this.isH1BFlag = false
                if(this.WorkPermitTypeEdit == 'CPT')
                    this.isCPT = true
                else
                    this.isCPT = false
            }
        }
    },
    removeWorkAuth(obj){
        this.workAuthPrevDetails.forEach((t) => {
            if(t.Id == obj.Id)
                Vue.set(t, 'isRemoved', true)
        })
        this.$loading({'loadingText': 'Loading...'})
        ajax.put(`Employee/${this.EmpId}/RemoveWorkAuthorizationHistory?workAuthId=${obj.Id}`,{},(res)=>{
          this.$loading({}).close()
            if(res.data.State == true){
                this.$message({
                    type: 'success',
                    message: res.data.Message
                })
            }
            else{
                this.$message({
                    type: 'error',
                    message: res.data.Message
                })
            }
            events.fire("WorkAuthSaveSuccess")

        });

    },
    WorkAuthEdit(workAuthPrevRec){
        this.$v.WorkPermitTypeEdit.$touch()
        this.$v.CompanyNameEdit.$touch()
        this.$v.CardNumberEdit.$touch()
        this.$v.ReceiptNumberEdit.$touch()
        this.$v.WorkAuthFromDateEditValue.$touch()
        this.$v.WorkAuthToDateEditValue.$touch()
        var isEAD = false;
        var isCardValidated = false;
        if(!(this.WorkPermitTypeEdit =='EAD OTHERS' || this.WorkPermitTypeEdit =='STEM OPT' || this.WorkPermitTypeEdit =='OPT EAD' || this.WorkPermitTypeEdit =='CPT' || this.WorkPermitTypeEdit =='Green Card'|| this.WorkPermitTypeEdit =='US Citizen')){
            isCardValidated = !this.$v.ReceiptNumberEdit.$invalid
            isEAD = false;
        }
        else{
            isCardValidated = !this.$v.CardNumberEdit.$invalid
            isEAD = true;
        }
        if(this.$v.WorkPermitTypeEdit.$invalid == false && isCardValidated && this.$v.CompanyNameEdit.$invalid == false && this.$v.WorkAuthFromDateEditValue.$invalid == false && this.$v.WorkAuthToDateEditValue.$invalid == false){
            var cardNo;
            if(!isEAD)
                cardNo = this.ReceiptNumberEdit
            else
                cardNo = this.CardNumberEdit

            var docs = this.EditAttachments != null && this.EditAttachments.length > 0 ?
                        this.EditAttachments.map(function(item) {
                            return item['Value'];
                        }) : null;
            let params = {
                "Id":workAuthPrevRec.Id,
                "WorkAuthType" :this.WorkPermitTypeEdit ,
                "CardNumber" : cardNo,
                "CompanyName" : this.CompanyNameEdit,
                "StartDate" : this.WorkAuthFromDateEditValue,
                "EndDate" : this.WorkAuthToDateEditValue,
                "Documents" : docs
            }
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.put(`Employee/${this.EmpId}/UpdateWorkAuthorizationHistory`,params,(res)=>{
                if(res.data.State == true){
                    this.$loading({}).close()
                    this.addWorkAuthDisable = false
                    this.addAnotherWorkAuth = false
                    this.clearValuesEdit()
                    this.resetEdit()
                    this.$message({
                        type: 'success',
                        message: res.data.Message
                    })
                    events.fire("WorkAuthSaveSuccess")
                }
                else{
                    this.$loading({}).close()
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    })
                    events.fire("WorkAuthSaveSuccess")
                }
            });

        }

    },
    cancelEdit(obj){
        this.workAuthPrevDetails.forEach((t) => {
            if(t.Id == obj.Id)
            Vue.set(t, 'isEdit', false)
            Vue.set(t, 'isEditDisabled', false)
        })
        events.fire("WorkAuthSaveSuccess")
    }

  },
  watch: {
    openModal(val) {
      this.show = val;
        if(this.show){
            this.EmpId = this.consultantObj.EmployeeId
            this.EmpStartDate = this.empStartDate
            this.getWorkAuthorizationHistory()
            this.clearValues()
            this.reset()
        }
        else{
            this.showSection = false
        }
    },
    show(val) {
      this.$emit("update:openModal", val);
    },
    WorkPermitType(){
      if(!(this.WorkPermitType =='EAD OTHERS' || this.WorkPermitType =='STEM OPT' || this.WorkPermitType =='OPT EAD' || this.WorkPermitType =='CPT' || this.WorkPermitType =='Green Card'|| this.WorkPermitType =='US Citizen')){
         this.isH1B = true
         this.ReceiptNumber = ''
      }
      else{
        this.isH1B = false
        this.CardNumber = ''
        if(this.WorkPermitType == 'CPT')
            this.isCPT = true
        else
            this.isCPT = false
      }
    },
    WorkPermitTypeEdit(){
        if(!(this.WorkPermitTypeEdit =='EAD OTHERS' || this.WorkPermitTypeEdit =='STEM OPT' || this.WorkPermitTypeEdit =='OPT EAD' || this.WorkPermitTypeEdit =='CPT' || this.WorkPermitTypeEdit =='Green Card'|| this.WorkPermitTypeEdit =='US Citizen')){
            this.isH1BFlag = true
        }
        else{
            this.isH1BFlag = false
            if(this.WorkPermitTypeEdit == 'CPT')
                this.isCPT = true
            else
                this.isCPT = false
        }
    }

  }
};
</script>

<style lang="scss" scoped>
.heading{
    color:#000;
    font-size:16px;
    font-weight:bold;
    margin-left:13px;
}
.sub-heading{
    color:#090a0c;
    font-size:14px;
    font-weight:600;
    margin-left: 13px;
}
.hr_line{
    border-top:1px solid #dcdcdc;
    margin-top:15px;
}
.docList{
    margin: 15px 0px 0px 15px;
    padding: 0px 0px 10px 0px;
}
.section{
  width:50%;
  float:left
}
.section p{
    line-height: 20px;
}
img{
    margin-top: -10px;
}
.para{
font-size: 14px;
font-weight: 600;
color:#090a0c;
}
.view-link{
    text-decoration: underline;
    font-size: 14px;
    font-weight: bold;
    color:#4a90e2;
    padding: 10px 0px 0px 10px;
}
a{
    padding-top: 10px;
}
h1 {
  letter-spacing: 1.5px;
  font-weight: 400;
  font-size: 2.4em;
}
#content {
  margin-top: 50px;
  text-align: center;
  margin-left: 8px;
}
.timeline {
  border-left: 2px solid #004ffc;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  background: fade(white, 3%);
  color: fade(white, 80%);
  margin: 50px auto;
  letter-spacing: 0.5px;
  position: relative;
  line-height: 1.4em;
  font-size: 1.03em;
  padding: 0 35px 0px;
  list-style: none;
  text-align: left;
  font-weight: 100;

  h1 {
    letter-spacing: 1.5px;
    font-weight: 100;
    font-size: 1.4em;
  }

  h2,
  h3 {
    letter-spacing: 1.5px;
    font-weight: 400;
    font-size: 1.4em;
  }

  .event {
    border-bottom: 1px dashed fade(white, 10%);
    padding-bottom: (50px * 0.5);
    position: relative;

    &:last-of-type {
      padding-bottom: 0;
      margin-bottom: 0;
      border: none;
    }

    &:before,
    &:after {
      position: absolute;
      display: block;
      top: 0;
    }

    &:before {
      left: (((120px * 0.6) + 50px + 4px + 11px + (4px * 2)) * 1.5) * -1;
      color: fade(white, 40%);
      content: attr(data-date);
      text-align: right;
      font-weight: 100;
      font-size: 0.9em;
      min-width: 120px;
    }

    &:after {
      box-shadow: 0 0 0 2px fade(#004ffc, 100%);
      left: (35px + 4px + (17px * 0.35)) * -1;
      background: white;
      border-radius: 50%;
      height: 17px;
      width: 17px;
      content: "";
      border: 2px solid #004ffc;
    }
  }
}
.rcss-text-red{
  color: red;
}
label{
  font-size: 12px;
}
.divalign{
  margin-top: 10px;
  margin-left: 0px;
}
.work-auth{
    padding: 10px 10px 10px 40px;
    border-bottom: 1px dashed #dcdcdc;
}
.work-auth-heading{
    padding: 15px 10px 0px 40px;
}
.AddWorkAuthDisable{
  margin-top:8px;
  font-size:13px;
  padding: 20px 20px 0 50px;
  font-weight: bold;
  color: #333;
}

.AddWorkAuth{
  cursor:pointer;
  margin-top:10px;
  font-size:13px;
  padding: 20px 20px 0 50px;
  font-weight: bold;
  color: #333;
}
.select2-container .select2-selection--single{
    height:30px !important;

}
.remove-worklocation{
    float: right;
    color: #2e2e3b;
    font-size: 13px;
    font-weight: bold;
    //margin-top: 10px;
    padding-right: 25px;
}
.remove-worklocation .fa-minus{
    color: #f31d1d;
    padding: 2px 4px;
    border-radius: 50px;
    border: 1px solid #f31d1d;
    font-size: 10px;
}
.current-tag{
    font-size: 13px;
    padding: 5px 10px;
    border: 1px solid #5a8ed7;
    background: #5a8ed7;
    display: inline-block;
    border-radius: 30px;
    font-weight: 700;
    color: #fff;
    margin-left: 15px;
}
.attachments-view{
    margin-bottom: 5px;
    color:#4A90E2;
    margin-left: 0px;
    border: 1px solid #4A90E2 !important;
    background: #e6eff9 !important;
    padding: 5px 10px;
    display: inline-block;
    border-radius: 30px;
    font-weight: bold;
    float: left;
    margin-right: 2%;

}
.cross-mark{
    font-size: 15px;
    padding: 0px 5px;
    border-radius: 100%;
    cursor: pointer;
}
.cross-mark:hover{
    background: #c2c2c2;
    padding: 0px 5px;
    border-radius: 100%;
    text-decoration: none !important;
}
.no-workauth{
    padding:100px 0 30px;
    text-align: center;
}
</style>







// WEBPACK FOOTER //
// src/components/Profile/WorkAuthorizationHistoryPopup.vue